export default {
  PENDENTE_DATA :"DATA",
  PENDENTE_EXECUCAO :"EXECUÇÃO",
  PENDENTE_REVISAO :"REVISÃO",
  PENDENTE_GERAR_COBRANCA :"COBRANÇA",
  PENDENTE_PAGAMENTO :"A PAGAR",
  FINALIZADO :"FINALIZADO",
}